import React from "react";

/**
 * Loading Spinner Component
 * Displays a loading indicator with message
 */
const LoadingSpinner = () => {
  return (
    <div className="h-full flex items-center justify-center bg-white rounded-lg shadow-sm">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        <p className="mt-4 text-gray-600 text-sm">Loading products...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
